const { createSlice } = require('@reduxjs/toolkit');

const categorySelectionSlice = createSlice({
    name: "categorySelection",
    initialState: {
       categorySelectionName: ""
    },
    reducers: {
        setcategorySelection(state, action) {
            const categorySelectionName = action.payload;

            return state = {
                categorySelectionName
            };
        }
    },
});

export const { setcategorySelection } = categorySelectionSlice.actions;
export default categorySelectionSlice.reducer;